module.exports = __webpack_public_path__ + "static/media/header-1500.18e71201.webp";